export default function Divider() {
  return (
    <div className="py-4">
      <hr className="opacity-50" />
    </div>
  )
}
